import { Component, OnInit } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { ReportesClientesService } from '../../../services/reportes/reportes-clientes.service';
import { ClientesService } from "../../../services/clientes.service";
import { SucursalesService } from '../../../services/sucursales.service';

@Component({
    selector: 'app-reporte-clientes-general',
    templateUrl: './reporte-clientes-general.component.html'
})

export class ReporteClientesGeneralComponent implements OnInit {

    public reportData: any[] = [];
    public totales: any = {};
    public tiposCreditos: any[] = [];
    //Filtros
    public tipoCreditoSelected: any = '';
    public clienteSelected: number = null;
    //Helpers
    public isLoading: boolean = true;
    public isItemsArrayEmpty: boolean = null;
    public isNaN: Function = Number.isNaN;
    public isNumber: Function = this.helper.isNumber;

    //Typeahead utilities
    public tempClient: any = {};
    public searching = false;
    public searchFailed = false;
    public isARegisteredCliente = false;

    public sucursales: any[] = [];
    public sucursal: any = { id: null };
    public sucursalPorDefecto: string = "";

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesClientesService,
        public helper: ReportsHelperService,
        private creditosService: CreditosService,
        private sucursalesService: SucursalesService,
        private clientesService: ClientesService
    ) {

    }

    public ngOnInit() {
        this.setupDefaultState();
    }

    private setupDefaultState() {
        this.getTiposCreditos();
        this.getSucursales();
    }

    private getTiposCreditos() {
        this.creditosService.getTiposCreditos().subscribe(
            (response) => {
                const jsonResult = response.json();
                if (jsonResult.content) {
                    this.tiposCreditos = jsonResult.content;
                }
            }, error => {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if (error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }

    private getSucursales() {
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
            (response) => {
                const jsonResult = response.json();
                if (jsonResult.content) {
                    this.sucursales = jsonResult.content.data;
                    if (this.sucursales.length > 1) {
                        this.sucursalPorDefecto = "Seleccione";
                    } else if (this.sucursales.length > 0) {
                        this.sucursal = this.sucursales[0];
                    }
                    this.isLoading = false;
                    this.updateReporte();
                }

            }, error => {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);

            if (error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }


    sucursalChanged(sucursal) {
        if (sucursal) {
            this.sucursal = sucursal;
            this.updateReporte();
        }
    }

    public updateReporte() {

        let filters = this.getFiltros();

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.getReporteGeneral(filters).subscribe(
            (response) => {
                const jsonResult = response.json();
                let items = [];
                let totales = {};

                if (jsonResult.content) {
                    if (jsonResult.content.items) {
                        items = jsonResult.content.items;
                    }
                    if (jsonResult.content.totales) {
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
                this.isItemsArrayEmpty = this.reportData.length == 0;
            }, error => {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if (error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }

    public print() {
        //Imprimir pantalla
        window.print();
    }

    public descargar() {

        let filters = this.getFiltros();

        this.reportesService.exportReporteGeneralToExcel(filters).subscribe(
            (response) => {
                const fileUrl = window.URL.createObjectURL(response.blob());
                //Muestra el archivo en una nueva ventana
                window.open(fileUrl);
            }, error => {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if (error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }

    private getFiltros() {
        let filters = {
            cliente: this.clienteSelected,
            tipoCredito: this.tipoCreditoSelected,
            sucursal: this.sucursal.id
        }

        return filters;
    }

    /**
     * Typeahead functions
     */
    public formatter = (x: { nombre: string }) => x.nombre;

    public searchCliente = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(term =>
                this.clientesService.search({ nombre: term }).pipe(
                    tap(() => this.searchFailed = false),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    }))
            ),
            tap(() => this.searching = false)
        );


    public selectCliente(event: any) {
        this.isARegisteredCliente = true;
        //Se selecciona un cliente del listado
        this.clienteSelected = event.item.id;
        //Se actualiza el reporte con el cliente seleccionado
        this.updateReporte();
    }

    public onEmailChange() {
        //Este evento se dispara cuando se modifica de forma manual el valor del email
        //Por lo tanto ya no esta seleccionado un cliente
        this.isARegisteredCliente = false;
        this.clienteSelected = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/clientes/general/reporte-clientes-general.component.ts